<p lang="en" align="center">
    <strong>General Terms and Conditions</strong>
</p>
<h6 align="justify">
    Introduction
</h6>
<p align="justify">
    These General Terms and Conditions of Use (hereinafter "General Terms and Conditions") define the terms of use, rights and obligations of the user (hereinafter "you", "your") and the service provider company <strong>Table42 Ltd</strong>, Vurnikov trg 3, 4240 Radovljica (hereinafter "the administrator"), in relation to the use and operation of the following websites or mobile applications:
</p>
<p align="justify">
    www.table42.app (hereinafter "website")
</p>
<p align="justify">
    table42.app (hereinafter "application").
</p>
<p align="justify">
   A user is anyone who visits or uses any website or application of the administrator mentioned in this article. For the purposes of these General Terms and Conditions, end users who use the services of table42.app are considered to be users.
</p>
<p align="justify">
    The General Terms and Conditions apply to and bind all types of users who use the website or application of the administrator. The General Terms and Conditions are an integral part of any contract between the administrator and the user of the application or website, except in cases where these or other General Terms and Conditions provide otherwise. All provisions of these General Terms and Conditions of Business are general terms within the meaning of Article 120 of the Obligations Code (Official Gazette of the Republic of Slovenia, No. 97/07 and subsequent amendments), which supplement the contract and are binding as contract provisions.
</p>
<p align="justify">
    By using the website, application and services of the administrator, the user confirms and agrees that:
</p>
<ul>
    <li>
        <p align="justify">
            he has read and understood and will respect these General Terms and Conditions;
        </p>
    </li>
    <li>
        <p align="justify">
            these General Terms and Conditions are legally binding on him;
        </p>
    </li>
    <li>
        <p align="justify">
            he is 18 years of age or older and is legally competent to do business.
        </p>
    </li>
</ul>
<h6 align="justify">
    2. User registration
</h6>
<p align="justify">
    In order to use the services of table42.app, the user must first register on the application or website. By completing the registration, the user acquires the right to use the services and place an order or make a reservation for the desired service from various service providers. With registration, the user is deemed to accept these terms and conditions and agree to the Administrator's Personal Data Protection Policy, published on his website. The user must fill in all required fields with his true data. Issuing for another legal or natural person is a punishable act.
</p>
<p align="justify">
    The user is solely responsible for appropriate handling of the user account and protecting their password from unauthorized access by third parties. The administrator assumes no responsibility for any abuse of the user account.
</p>
<h6 align="justify">
    <a name="_Hlk39841157"></a>
    3. User content
</h6>
<p align="justify">
    Table42.app is a platform for online ordering of users for services from various providers. Table42.app allows users to self-service and privately select services and obtain advance information on the price of the desired service from providers.
</p>
<p align="justify">
    The user agrees to ensure that his user content is true and legal. The administrator of the website and application is not responsible for user content published on this application or website. User content is the property of the users and they are responsible for it. Nevertheless, the administrator reserves the right to block, delete or edit any content that it considers to be in violation of the law or otherwise unacceptable in its sole discretion.
</p>
<p align="justify">
    By publishing user content, the user agrees to its display in the application and to the associated promotional use of this content. The user agrees to promptly notify the administrator of the portal of any irregularities regarding the publication of user content.
</p>
<h6 align="justify">
    4. Placing an order for services and prices
</h6>
<p align="justify">
    The user places an order for the selected service with the selected provider when he confirms the desired service time in the application by pressing the "reserve" option. The user receives confirmation of the reserved service time at the user's email address or by SMS message to the user's phone, depending on the method chosen by the user. Changes or cancellations of the order by the user are possible only with prior agreement between the user and the service provider. The administrator assumes no responsibility for the possibility of changes or cancellations of the ordered service.
</p>
<p align="justify">
    The user pays for the ordered service directly to the selected service provider after the service has been performed. All prices of service providers in the application are quoted in EUR and include the value-added tax (VAT).
</p>
<h6 align="justify">
    5. Personal data protection and user content
</h6>
<p align="justify">
    The manager processes personal data of users in accordance with European legislation (Regulation (EU) 2016/697 on the protection of individuals with regard to the processing of personal data and on the free movement of such data (hereinafter: the General Regulation or GDPR)) and applicable Slovenian legislation on the protection of personal data and internal acts. Information on the processing of personal data and the rights of individuals arising therefrom are more specifically defined in the Privacy Policy published at: (insert link to published policy).
</p>
<p align="justify">
    During the term of the contract and thereafter, the manager may use non-personal or anonymized data to improve the service, statistical analysis, technical support, and other business purposes.
</p>
<p align="justify">
    The manager will process the personal data provided to him by the user for the purpose of ensuring the rights of the user under this contract, for checking the compliance of the use of the application with the general terms of business, for analyzing and studying user habits, for evaluating the offer, for predicting the user's interests, economic position, and optimizing offers and costs, for improving customer satisfaction, for resolving your questions, proposals, objections or complaints, and for informing about technical, legal, and other issues. Occasionally, the manager will ask the user for feedback on satisfaction with the service. The manager may also use the user's data for the purpose of direct marketing and prepare special offers for the user and inform him about them in a way chosen by the user (by e-mail, SMS, or in the application).
</p>
<p align="justify">
    User cannot object to other purposes of processing personal data related to them in connection with use, except by opting out of the contract in accordance with these general terms. In this case, the user must deactivate their account.
</p>
<p align="justify">
    The manager does not disclose the personal data of users to third parties, except to:
</p>
<ul>
    <li>
        <p align="justify">
            external contractors who process the data exclusively in the name, on behalf of, in accordance with instructions and under the control of the manager (e.g. call centers, printers, advertising agencies);
        </p>
    </li>
    <li>
        <p align="justify">
            state authority on the basis of their justified request for the purpose of conducting a specific procedure;
        </p>
    </li>
    <li>
        <p align="justify">
            if they are provided with written personal consent or authorization from the user.
        </p>
    </li>
</ul>
<h6 align="justify">
    6. User support
</h6>
<p align="justify">
    The administrator provides professional and technical assistance to all users in using the website or application, during regular business hours. If the user has any questions or issues regarding the use of the website/application, they can send their request to the email address: <em>stik@table42.app</em>
</p>
<h6 align="justify">
    7. Copyright
</h6>
<p align="justify">
    The content of the website and application is owned by the administrator and is therefore copyright protected by valid laws. The content also includes the graphic image of the website and application with all graphic elements. Any copying and publishing of this content on other websites or applications is prohibited, except with the written permission of the administrator.
</p>
<h6 align="justify">
    8. Limitation of liability
</h6>
<p align="justify">
    The user agrees not to use the website and applications of the administrator listed in the first article of these terms for illegal purposes or purposes that could harm the administrator or other users. It is also not allowed to disable or obstruct use by other users. The administrator is not responsible for the correctness and timeliness of the data published by the user and is not responsible for the actions carried out by the user based on the published data. The administrator is not responsible for any damage that may arise from any technical problems or other disruptions.
</p>
<p align="justify">
    The websites and applications listed in the first article of these terms may also contain links to third-party websites. The administrator is not responsible for the privacy and content on these websites. The administrator also does not guarantee (neither contractually nor compensatory or otherwise) any loss or damage that may arise as a result of the use or inability to use, loss or error in data, and the accuracy of data.
</p>
<p align="justify">
    9. Duration and termination of the contract
</p>
<p align="justify">
    By using the table42.app services in the application or web portal with the administrator, the user enters into a contract for the use of the table42.app services, which includes these General Terms and Conditions. This contract is concluded for an indefinite period. The user has the right to withdraw from the contract, which they can do by making the appropriate changes in the application or by notification by e-mail (<em>stik@table42.app</em>), or in writing by registered mail to the address of the administrator, but first must prove themselves to be a user in order to prevent abuse.
</p>
<p align="justify">
    In the event that the user seriously violates the rules for appropriate communication levels (harassment, offensive language, discrimination, etc.), or performs activities that are in violation of the contract, these general terms and conditions or legislation, the administrator has the right to immediately terminate the contract and permanently or temporarily block or delete the user account.
</p>
<p align="justify">
    The administrator reserves the right to terminate the contract without notice, without stating a reason.
</p>
<h6 align="justify">
    10. Dispute resolution
</h6>
<p align="justify">
    The laws of the Republic of Slovenia shall apply to the structure, validity, enforcement, and interpretation of these General Terms and Conditions. The administrator of the portal will try to resolve any disputes arising from the breach of these General Terms and Conditions by peaceful means. If all other options for out-of-court settlement have been exhausted, the competent court of jurisdiction based on the seat of the administrator shall be competent to resolve any disputes.
</p>
<h6 align="justify">
    11. Final statement
</h6>
<h6 align="justify">
</h6>
<p align="justify">
    The administrator has the right to supplement, correct, or change the General Terms and Conditions of Business. In this case, the user will be informed of the proposed changes to the General Terms and Conditions (by email, notice on the web portal or in the application) before they come into effect. If the user does not agree with the changes to the General Terms and Conditions, they may terminate the contract without notice, concluded on the basis of these General Terms and Conditions. The user's termination shall be deemed valid if it is made in the manner specified in Article 8 of these General Terms and Conditions. The continued use of the administrator's services after the start of the new terms and conditions means that the user agrees to these terms and conditions.
</p>
<p align="justify">
    For any questions or comments regarding these General Terms and Conditions, the administrator is available to the user at the email address <em>stik@table42.app</em>
</p>
<p align="justify">
    These General Terms and Conditions apply and are in effect from 1.10.2022 onwards.
</p>
<p align="justify">
    In Radovljica, October 1st, 2022.
</p>